module.exports = __webpack_public_path__ + "static/media/blog_grid_5.dc59bc48.jpg";